/**
 * T035/T122/T133: Root Layout Component
 * Main layout with header, sidebar, and content area
 * Responsive: mobile-first with sidebar hidden on small screens
 */

import { Outlet } from '@tanstack/react-router'
import { Header } from './header'
import { Sidebar, MobileSidebar } from './sidebar'
import { OfflineBanner } from '@/components/common/offline-banner'
import { useUIStore } from '@/stores/ui'
import { cn } from '@/lib/utils'

export function RootLayout() {
  const sidebarCollapsed = useUIStore((state) => state.sidebarCollapsed)

  return (
    <div className="flex min-h-screen flex-col">
      <OfflineBanner />
      <Header />
      <div className="flex flex-1">
        <Sidebar />
        <MobileSidebar />
        <main
          className={cn(
            'flex-1 transition-all duration-200',
            // No margin on mobile, margin on desktop based on sidebar state
            'md:ml-16',
            !sidebarCollapsed && 'md:ml-64'
          )}
        >
          <div className="container mx-auto p-4 md:p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
